/* SafetyClip 3D. Blikje en clip op ware maat, in millimeters gebouwd.
   Blikje: koepelbodem met standrand, ingetrokken schouder, dubbele felsrand,
   countersink, traanvormig drinkgat met ingedrukt paneeltje, klinknagel en
   stay-on-tab. Het lipje van het blikje ligt altijd bovenop de clip; de clip
   draait eronder door en blijft binnen de felsrand.
   Gebruik: <div data-sc-clip3d data-color="#4CAF3E" data-can="1" data-size="std"></div>
   Meerdere clips (bundels): <div data-sc-clip3d data-colors="#1B7FD4,#4CAF3E,..."></div>
     Het aantal kleuren bepaalt het aantal clips: 2 naast elkaar, 4 in een
     rondje, 7 als bloem, meer als raster. Zonder blikje.
   API: el.scClip.setColor / setColors([hex,...]) / setTurn(graden) / setLift(0..1)
        / setTilt(rad) / setAuto(bool) / setView(ry,rx) / setSize(id) / setCan(bool) */
(function () {
  if (window.SCClip3D) return;
  var THREE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  var loading = null;
  function loadThree() {
    if (window.THREE) return Promise.resolve();
    if (loading) return loading;
    loading = new Promise(function (res, rej) {
      var s = document.createElement('script'); s.src = THREE_URL; s.async = true;
      s.onload = res; s.onerror = rej; document.head.appendChild(s);
    });
    return loading;
  }
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  var SIZES = {
    std:   { d: 66.3, h: 115.2, end: 202 },
    sleek: { d: 57.0, h: 115.0, end: 202 },
    slim:  { d: 53.0, h: 134.0, end: 200 },
    big:   { d: 66.3, h: 168.0, end: 202 }
  };
  var SEAM = { 202: 54.0, 200: 51.6 };

  /* texturen worden door alle blikjes op de pagina gedeeld */
  var TEX = null;
  function tex(T) {
    if (TEX) return TEX;
    var W = 1024, H = 512;
    var cb = document.createElement('canvas'); cb.width = W; cb.height = H;
    var cr = document.createElement('canvas'); cr.width = W; cr.height = H;
    var b = cb.getContext('2d'), r = cr.getContext('2d');
    b.fillStyle = '#808080'; b.fillRect(0, 0, W, H);
    r.fillStyle = '#b4b4b4'; r.fillRect(0, 0, W, H);
    for (var i = 0; i < 1100; i++) {
      var px = Math.random() * W, a = .006 + Math.random() * .016;
      b.strokeStyle = 'rgba(255,255,255,' + a + ')'; b.lineWidth = .5 + Math.random() * 1.2;
      b.beginPath(); b.moveTo(px, 0); b.lineTo(px, H); b.stroke();
      r.strokeStyle = 'rgba(255,255,255,' + (a * 2.2) + ')'; r.lineWidth = .5 + Math.random() * 1.2;
      r.beginPath(); r.moveTo(px, 0); r.lineTo(px, H); r.stroke();
    }
    for (var j = 0; j < 900; j++) {
      var x = Math.random() * W, y = Math.random() * H;
      var rad = 1.4 + Math.pow(Math.random(), 2.4) * 9, ry = rad * (1 + Math.random() * .6);
      b.save(); b.translate(x, y); b.scale(1, ry / rad);
      var g = b.createRadialGradient(-rad * .28, -rad * .28, rad * .1, 0, 0, rad);
      g.addColorStop(0, 'rgba(255,255,255,.95)');
      g.addColorStop(.62, 'rgba(190,190,190,.55)');
      g.addColorStop(1, 'rgba(40,40,40,.65)');
      b.fillStyle = g; b.beginPath(); b.arc(0, 0, rad, 0, 6.284); b.fill(); b.restore();
      r.save(); r.translate(x, y); r.scale(1, ry / rad);
      r.fillStyle = 'rgba(30,30,30,.85)';
      r.beginPath(); r.arc(0, 0, rad * .92, 0, 6.284); r.fill(); r.restore();
    }
    var lc = document.createElement('canvas'); lc.width = 8; lc.height = 32;
    var lx = lc.getContext('2d'); lx.fillStyle = '#808080'; lx.fillRect(0, 0, 8, 32);
    for (var k = 0; k < 32; k += 4) {
      lx.fillStyle = 'rgba(255,255,255,.55)'; lx.fillRect(0, k, 8, 1);
      lx.fillStyle = 'rgba(0,0,0,.35)'; lx.fillRect(0, k + 2, 8, 1);
    }
    var bt = new T.CanvasTexture(cb), rt = new T.CanvasTexture(cr), lt = new T.CanvasTexture(lc);
    bt.wrapS = bt.wrapT = rt.wrapS = rt.wrapT = lt.wrapS = lt.wrapT = T.RepeatWrapping;
    bt.repeat.set(2, 1); rt.repeat.set(2, 1); lt.repeat.set(.34, .34);
    var face = function (draw) {
      var c = document.createElement('canvas'); c.width = c.height = 256;
      draw(c.getContext('2d'), 256); return c;
    };
    var side = function (x, s) {
      var g2 = x.createLinearGradient(0, 0, 0, s);
      g2.addColorStop(0, '#f2f5fa'); g2.addColorStop(.38, '#c8cfd9');
      g2.addColorStop(.52, '#8d949f'); g2.addColorStop(1, '#26292e');
      x.fillStyle = g2; x.fillRect(0, 0, s, s);
      x.fillStyle = 'rgba(255,255,255,.85)'; x.fillRect(s * .12, s * .10, s * .26, s * .34);
      x.fillStyle = 'rgba(255,255,255,.35)'; x.fillRect(s * .62, s * .18, s * .18, s * .22);
    };
    var cube = new T.CubeTexture([
      face(side), face(side),
      face(function (x, s) { x.fillStyle = '#ffffff'; x.fillRect(0, 0, s, s); }),
      face(function (x, s) { x.fillStyle = '#191b1f'; x.fillRect(0, 0, s, s); }),
      face(side), face(side)
    ]);
    cube.needsUpdate = true; cube.encoding = T.sRGBEncoding;
    TEX = { bump: bt, rough: rt, layers: lt, cube: cube };
    return TEX;
  }

  function build(el) {
    var T = window.THREE, tx = tex(T);
    var W = function () { return el.clientWidth || 320; };
    var H = function () { return el.clientHeight || el.clientWidth || 320; };

    var renderer = new T.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));
    renderer.setSize(W(), H());
    renderer.outputEncoding = T.sRGBEncoding;
    renderer.toneMapping = T.ACESFilmicToneMapping;
    renderer.toneMappingExposure = .92;
    renderer.domElement.style.cssText = 'width:100%;height:100%;display:block;touch-action:none;cursor:grab';
    el.appendChild(renderer.domElement);

    var scene = new T.Scene();
    var cam = new T.PerspectiveCamera(28, 1, 1, 6000);
    scene.add(new T.HemisphereLight(0xdfe6f2, 0x1a1c20, .48));
    var key = new T.DirectionalLight(0xffffff, .92); key.position.set(180, 340, 220); scene.add(key);
    var fill = new T.DirectionalLight(0xbfd0e6, .42); fill.position.set(-260, 120, 140); scene.add(fill);
    var rimL = new T.DirectionalLight(0xffffff, .7); rimL.position.set(-120, 200, -300); scene.add(rimL);

    var envTex = tx.cube;
    try {
      var pm = new T.PMREMGenerator(renderer); pm.compileCubemapShader();
      envTex = pm.fromCubemap(tx.cube).texture;
    } catch (e) {}

    var matBody = new T.MeshStandardMaterial({
      color: 0xD3D7DC, metalness: .92, roughness: .30, envMap: envTex,
      bumpMap: tx.bump, bumpScale: .55, roughnessMap: tx.rough, side: T.DoubleSide
    });
    var matLid = new T.MeshStandardMaterial({ color: 0xC6CACF, metalness: .88, roughness: .36, envMap: envTex, side: T.DoubleSide });
    var matTab = new T.MeshStandardMaterial({ color: 0xD8DCE1, metalness: .95, roughness: .24, envMap: envTex, envMapIntensity: 1.1, side: T.DoubleSide });
    var matDark = new T.MeshStandardMaterial({ color: 0x0A0B0D, metalness: .2, roughness: .9 });
    function clipMat(hex) {
      return new T.MeshStandardMaterial({
        color: new T.Color(hex).convertSRGBToLinear(),
        metalness: 0, roughness: .55, envMap: envTex, envMapIntensity: .13,
        bumpMap: tx.layers, bumpScale: .42
      });
    }
    var matClip = clipMat(el.dataset.color || '#4CAF3E');

    function teardrop(L, Wd) {
      var p = new T.Path();
      p.moveTo(0, -L * .5);
      p.bezierCurveTo(Wd * .30, -L * .46, Wd * .5, -L * .12, Wd * .5, L * .14);
      p.bezierCurveTo(Wd * .5, L * .42, Wd * .28, L * .5, 0, L * .5);
      p.bezierCurveTo(-Wd * .28, L * .5, -Wd * .5, L * .42, -Wd * .5, L * .14);
      p.bezierCurveTo(-Wd * .5, -L * .12, -Wd * .30, -L * .46, 0, -L * .5);
      return p;
    }
    function teardropShape(L, Wd) {
      var s = new T.Shape(), p = teardrop(L, Wd);
      s.curves = p.curves.slice(); s.currentPoint = p.currentPoint.clone();
      return s;
    }

    function buildCan(spec) {
      var g = new T.Group();
      var R = spec.d / 2, Hh = spec.h, seamR = SEAM[spec.end] / 2;
      var ringR = R * .71, domeH = R * .30, neckH = Hh > 125 ? 21 : 18.5;
      var p = [];
      function P(r, y) { p.push(new T.Vector2(r, y)); }
      P(0, domeH);
      P(ringR * .26, domeH * .975); P(ringR * .50, domeH * .87);
      P(ringR * .72, domeH * .64); P(ringR * .88, domeH * .37);
      P(ringR * .96, domeH * .155); P(ringR * .995, 1.05);
      P(ringR + .35, .22); P(ringR + 1.25, 0);
      P(ringR + 2.3, .4); P(ringR + 4.2, 1.9);
      P(R - 2.1, 4.4); P(R - .55, 7.3); P(R, 10.6);
      P(R, Hh - neckH);
      for (var i = 1; i <= 16; i++) {
        var t = i / 16;
        P(R + (seamR - 1.55 - R) * (t * t * (3 - 2 * t)), Hh - neckH + (neckH - 5.0) * t);
      }
      P(seamR - 1.35, Hh - 4.15);
      P(seamR - .15, Hh - 3.35);
      P(seamR, Hh - 2.6); P(seamR, Hh - 1.15);
      P(seamR - .62, Hh - .22); P(seamR - 1.55, Hh);
      P(seamR - 2.35, Hh - .55); P(seamR - 2.55, Hh - 1.7);
      P(seamR - 2.62, Hh - 3.0);
      P(seamR - 2.85, Hh - 4.9);
      P(seamR - 3.30, Hh - 5.5);
      P(seamR - 3.85, Hh - 5.15);
      P(seamR - 4.10, Hh - 4.6);
      g.add(new T.Mesh(new T.LatheGeometry(p, 128), matBody));

      var panelR = seamR - 4.0, panelY = Hh - 4.6;
      var holeL = seamR * .58, holeW = seamR * .42, holeOff = seamR * .52;

      var panelShape = new T.Shape();
      panelShape.absarc(0, 0, panelR, 0, Math.PI * 2, false);
      var hole = teardrop(holeL, holeW);
      hole.curves.forEach(function (c) {
        ['v0', 'v1', 'v2', 'v3'].forEach(function (k) { if (c[k]) c[k].y -= holeOff; });
      });
      panelShape.holes.push(hole);
      var panel = new T.Mesh(new T.ExtrudeGeometry(panelShape, { depth: .38, bevelEnabled: false, curveSegments: 64 }), matLid);
      panel.rotation.x = -Math.PI / 2; panel.position.y = panelY;
      g.add(panel);

      var ringShape = new T.Shape(), outer = teardrop(holeL + 2.4, holeW + 2.4);
      ringShape.curves = outer.curves.slice(); ringShape.currentPoint = outer.currentPoint.clone();
      ringShape.holes.push(teardrop(holeL, holeW));
      var scoreRing = new T.Mesh(new T.ExtrudeGeometry(ringShape, {
        depth: .34, bevelEnabled: true, bevelThickness: .12, bevelSize: .18, bevelSegments: 2, curveSegments: 48
      }), matLid);
      scoreRing.rotation.x = -Math.PI / 2;
      scoreRing.position.set(0, panelY + .08, holeOff);
      g.add(scoreRing);

      var flapPivot = new T.Group();
      flapPivot.position.set(0, panelY + .2, holeOff - holeL * .5);
      var flap = new T.Mesh(new T.ExtrudeGeometry(teardropShape(holeL - .5, holeW - .6), {
        depth: .32, bevelEnabled: false, curveSegments: 40
      }), matLid);
      flap.rotation.x = -Math.PI / 2; flap.position.z = holeL * .5 - .25;
      flapPivot.add(flap); flapPivot.rotation.x = 1.72;
      g.add(flapPivot);

      var dark = new T.Mesh(new T.CircleGeometry(seamR - 5.2, 48), matDark);
      dark.rotation.x = -Math.PI / 2; dark.position.y = panelY - 14;
      g.add(dark);

      var bubble = new T.Mesh(new T.CylinderGeometry(4.0, 4.7, .6, 44), matLid);
      bubble.position.y = panelY + .48; bubble.scale.z = 1.25; g.add(bubble);
      var rivet = new T.Mesh(new T.CylinderGeometry(2.4, 2.6, 1.1, 28), matTab);
      rivet.position.y = panelY + .95; g.add(rivet);

      return {
        group: g, R: R, H: Hh, seamR: seamR, panelY: panelY, panelR: panelR,
        holeL: holeL, holeW: holeW, holeOff: holeOff,
        clipR: seamR - 3.0, rivetY: panelY + 1.5
      };
    }

    /* het lipje van het blikje: vlak deel bovenop de clip, knik naar de klinknagel */
    function buildTab(s, restY) {
      var tl = s.seamR / 27;
      var t2 = new T.Shape();
      t2.moveTo(-4.0 * tl, -6.4 * tl);
      t2.bezierCurveTo(-4.7 * tl, -2.4 * tl, -6.3 * tl, .8 * tl, -6.3 * tl, 5.0 * tl);
      t2.lineTo(-6.3 * tl, 13.6 * tl);
      t2.bezierCurveTo(-6.3 * tl, 18.4 * tl, -3.5 * tl, 20.4 * tl, 0, 20.4 * tl);
      t2.bezierCurveTo(3.5 * tl, 20.4 * tl, 6.3 * tl, 18.4 * tl, 6.3 * tl, 13.6 * tl);
      t2.lineTo(6.3 * tl, 5.0 * tl);
      t2.bezierCurveTo(6.3 * tl, .8 * tl, 4.7 * tl, -2.4 * tl, 4.0 * tl, -6.4 * tl);
      t2.bezierCurveTo(2.6 * tl, -8.2 * tl, -2.6 * tl, -8.2 * tl, -4.0 * tl, -6.4 * tl);
      var rh = new T.Path(); rh.absarc(0, -1.1 * tl, 2.75 * tl, 0, Math.PI * 2, false);
      t2.holes.push(rh);
      var fh = new T.Path();
      fh.moveTo(-3.5 * tl, 5.2 * tl); fh.lineTo(-3.5 * tl, 14.2 * tl);
      fh.bezierCurveTo(-3.5 * tl, 17.2 * tl, 3.5 * tl, 17.2 * tl, 3.5 * tl, 14.2 * tl);
      fh.lineTo(3.5 * tl, 5.2 * tl);
      fh.bezierCurveTo(3.5 * tl, 2.6 * tl, -3.5 * tl, 2.6 * tl, -3.5 * tl, 5.2 * tl);
      t2.holes.push(fh);
      var geo = new T.ExtrudeGeometry(t2, {
        depth: .5, bevelEnabled: true, bevelThickness: .1, bevelSize: .14, bevelSegments: 2, curveSegments: 28
      });
      geo.rotateX(-Math.PI / 2);
      geo.translate(0, 0, -1.1 * tl);
      var drop = restY - s.rivetY, bendFrom = -8.5 * tl, pos = geo.attributes.position;
      for (var i = 0; i < pos.count; i++) {
        var z = pos.getZ(i);
        var t = Math.max(0, Math.min(1.2, (z - bendFrom) / -bendFrom));
        var k = t <= 1 ? t * t * (3 - 2 * t) : 1 + (t - 1) * .8;
        pos.setY(i, pos.getY(i) - k * drop);
      }
      pos.needsUpdate = true; geo.computeVertexNormals();
      var grp = new T.Group(); grp.position.y = restY;
      grp.add(new T.Mesh(geo, matTab));
      return grp;
    }

    function buildClip(R, mat) {
      var m = mat || matClip;
      var g = new T.Group();
      var Tk = 2.6, nw = R * .34, nc = R * .09, mx = R * .72,
          my = -Math.sqrt(Math.max(0, R * R - mx * mx)), cy = -R * .62, wy = -R * .15;
      var d = new T.Shape();
      d.moveTo(mx, my);
      d.absarc(0, 0, R, Math.atan2(my, mx), Math.atan2(my, -mx) + Math.PI * 2, false);
      d.quadraticCurveTo(-nw, cy, -nw, wy);
      d.lineTo(-nw, nc);
      d.absarc(0, nc, nw, Math.PI, 0, true);
      d.lineTo(nw, wy);
      d.quadraticCurveTo(nw, cy, mx, my);
      g.add(new T.Mesh(new T.ExtrudeGeometry(d, {
        depth: Tk, bevelEnabled: true, bevelThickness: .32, bevelSize: .32, bevelSegments: 2, curveSegments: 96
      }), m));

      var o = R * .062, lip = new T.Shape();
      lip.moveTo(-mx + R * .03, my + R * .08);
      lip.quadraticCurveTo(-nw - o, cy, -nw - o, wy);
      lip.lineTo(-nw - o, nc);
      lip.absarc(0, nc, nw + o, Math.PI, 0, true);
      lip.lineTo(nw + o, wy);
      lip.quadraticCurveTo(nw + o, cy, mx - R * .03, my + R * .08);
      lip.lineTo(mx, my);
      lip.quadraticCurveTo(nw, cy, nw, wy);
      lip.lineTo(nw, nc);
      lip.absarc(0, nc, nw, 0, Math.PI, false);
      lip.lineTo(-nw, wy);
      lip.quadraticCurveTo(-nw, cy, -mx, my);
      lip.closePath();
      g.add(new T.Mesh(new T.ExtrudeGeometry(lip, { depth: Tk + .25, bevelEnabled: false, curveSegments: 96 }), m));

      var gw = R * .30, g0 = R * .82, g1 = R * 1.10, rr = R * .07, gr = new T.Shape();
      gr.moveTo(-gw + rr, g0); gr.lineTo(gw - rr, g0);
      gr.quadraticCurveTo(gw, g0, gw, g0 + rr); gr.lineTo(gw, g1 - rr);
      gr.quadraticCurveTo(gw, g1, gw - rr, g1); gr.lineTo(-gw + rr, g1);
      gr.quadraticCurveTo(-gw, g1, -gw, g1 - rr); gr.lineTo(-gw, g0 + rr);
      gr.quadraticCurveTo(-gw, g0, -gw + rr, g0);
      g.add(new T.Mesh(new T.ExtrudeGeometry(gr, {
        depth: Tk + 1.4, bevelEnabled: true, bevelThickness: .35, bevelSize: .35, bevelSegments: 3, curveSegments: 20
      }), m));
      for (var i = 0; i < 4; i++) {
        var rb = new T.Mesh(new T.BoxGeometry(gw * 1.75, .7, .45), m);
        rb.position.set(0, g0 + R * .045 + i * R * .062, Tk + 1.4 + .12);
        g.add(rb);
      }
      g.rotation.x = -Math.PI / 2;
      var turn = new T.Group(); turn.add(g);
      turn.userData.top = Tk;
      return turn;
    }

    /* opstelling voor meerdere clips: 2 naast elkaar, 4 in een rondje,
       7 als bloem (1 midden, 6 eromheen), meer als gecentreerd raster */
    function layout(n, R) {
      var out = [], i;
      if (n === 2) {
        out.push({ x: -R * 1.18, z: R * .16, rot: .5 });
        out.push({ x: R * 1.18, z: -R * .16, rot: -2.2 });
      } else if (n <= 4) {
        for (i = 0; i < n; i++) {
          var a4 = (Math.PI * 2 * i / n) + Math.PI / 4;
          out.push({ x: Math.cos(a4) * R * 1.85, z: Math.sin(a4) * R * 1.85, rot: -a4 - Math.PI / 2 });
        }
      } else if (n <= 7) {
        out.push({ x: 0, z: 0, rot: 0 });
        for (i = 1; i < n; i++) {
          var a7 = Math.PI * 2 * (i - 1) / (n - 1) - Math.PI / 2;
          out.push({ x: Math.cos(a7) * R * 2.5, z: Math.sin(a7) * R * 2.5, rot: -a7 - Math.PI / 2 });
        }
      } else {
        var cols = Math.ceil(Math.sqrt(n * 1.5));
        var rows = Math.ceil(n / cols);
        var sp = R * 2.5;
        for (i = 0; i < n; i++) {
          var cx2 = (i % cols) - (cols - 1) / 2;
          var cz2 = Math.floor(i / cols) - (rows - 1) / 2;
          out.push({ x: cx2 * sp, z: cz2 * sp, rot: i * 2.399 });
        }
      }
      return out;
    }

    var hasCan = el.dataset.can === '1';
    var sizeId = el.dataset.size || 'std';
    var multi = null;
    if (el.dataset.colors) {
      multi = el.dataset.colors.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (multi.length < 2) multi = null;
      else hasCan = false;
    }
    var root = new T.Group(); scene.add(root);
    var canGroup = null, clipGroup = null, tabUp = null, tabFlat = null, spec = null, shadow = null;
    var multiMats = [];

    function frame() {
      var box = new T.Box3().setFromObject(root);
      var c = new T.Vector3(), sz = new T.Vector3();
      box.getCenter(c); box.getSize(sz);
      var rad = Math.sqrt(sz.x * sz.x + sz.y * sz.y + sz.z * sz.z) * .5;
      var mult = parseFloat(el.dataset.dist || '4.6') / 4.6;
      return { cy: c.y, rad: rad, mult: mult, dist: rad / Math.sin(28 * Math.PI / 360) * mult, low: box.min.y, sx: sz.x, sz: sz.z };
    }
    var fit = { cy: 0, rad: 40, mult: 1, dist: 200, low: 0, sx: 60, sz: 60 };

    function rebuild() {
      if (canGroup) root.remove(canGroup);
      if (clipGroup && clipGroup.parent) clipGroup.parent.remove(clipGroup);
      if (shadow) { scene.remove(shadow); shadow = null; }
      var host;
      if (multi) {
        spec = { clipR: SEAM[202] / 2 - 3.0 };
        canGroup = new T.Group(); root.add(canGroup);
        clipGroup = null; tabUp = tabFlat = null;
        multiMats = [];
        var pos = layout(multi.length, spec.clipR);
        for (var mi = 0; mi < multi.length; mi++) {
          var mm = clipMat(multi[mi]);
          multiMats.push(mm);
          var cg = buildClip(spec.clipR, mm);
          cg.position.x = pos[mi].x;
          cg.position.z = pos[mi].z;
          cg.rotation.y = pos[mi].rot;
          canGroup.add(cg);
        }
      } else if (hasCan) {
        spec = buildCan(SIZES[sizeId] || SIZES.std);
        canGroup = spec.group; root.add(canGroup); host = canGroup;
        clipGroup = buildClip(spec.clipR);
        clipGroup.position.y = spec.panelY + .55;
        host.add(clipGroup);
        tabUp = buildTab(spec, spec.panelY + .55 + 2.6 + .5);
        tabFlat = buildTab(spec, spec.panelY + .85);
        host.add(tabUp); host.add(tabFlat); tabFlat.visible = false;
      } else {
        spec = { clipR: SEAM[202] / 2 - 3.0 };
        canGroup = new T.Group(); root.add(canGroup);
        clipGroup = buildClip(spec.clipR);
        canGroup.add(clipGroup);
        tabUp = tabFlat = null;
      }
      root.position.y = 0;
      fit = frame();
      root.position.y = -fit.cy;
      if (el.dataset.ground !== '0') {
        var cv = document.createElement('canvas'); cv.width = cv.height = 256;
        var c2 = cv.getContext('2d');
        var gr2 = c2.createRadialGradient(128, 128, 12, 128, 128, 128);
        gr2.addColorStop(0, '#fff'); gr2.addColorStop(.30, '#8c8c8c'); gr2.addColorStop(1, '#000');
        c2.fillStyle = gr2; c2.fillRect(0, 0, 256, 256);
        var w;
        if (multi) w = Math.max(fit.sx, fit.sz) * 2.1;
        else w = (hasCan ? spec.R * 6 : spec.clipR * 6);
        shadow = new T.Mesh(new T.PlaneGeometry(w, w), new T.MeshBasicMaterial({
          color: 0x000000, alphaMap: new T.CanvasTexture(cv), transparent: true, opacity: .5, depthWrite: false
        }));
        shadow.rotation.x = -Math.PI / 2;
        shadow.position.y = fit.low - fit.cy + (hasCan ? .2 : -spec.clipR * .55);
        scene.add(shadow);
      }
    }
    rebuild();

    var ry = parseFloat(el.dataset.ry || '3.6'), rx = parseFloat(el.dataset.rx || '.05');
    var vy = .004, down = false, px = 0, py = 0;
    var auto = el.dataset.auto !== '0', lift = 0, tilt = 0, turnDeg = 0;
    var c = renderer.domElement;
    if (el.dataset.drag !== '0') {
      c.addEventListener('pointerdown', function (e) {
        down = true; px = e.clientX; py = e.clientY;
        c.setPointerCapture(e.pointerId); c.style.cursor = 'grabbing';
      });
      c.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - px, dy = e.clientY - py; px = e.clientX; py = e.clientY;
        ry += dx * .012; rx = Math.max(-.5, Math.min(1.35, rx + dy * .010)); vy = dx * .012;
      });
      var up = function () { down = false; c.style.cursor = 'grab'; };
      c.addEventListener('pointerup', up); c.addEventListener('pointercancel', up);
    } else {
      c.style.cursor = 'default';
    }

    var api = {
      setColor: function (hex) { matClip.color.set(hex).convertSRGBToLinear(); },
      setColors: function (list) {
        if (!list || list.length < 2) return;
        if (!multi || list.length !== multi.length) { multi = list.slice(); hasCan = false; rebuild(); }
        else {
          multi = list.slice();
          for (var i = 0; i < multiMats.length; i++) multiMats[i].color.set(list[i]).convertSRGBToLinear();
        }
      },
      setTurn: function (deg) { turnDeg = deg; },
      setLift: function (v) { lift = v; },
      setTilt: function (v) { tilt = v; },
      setAuto: function (v) { auto = !!v; },
      setView: function (y, x) { ry = y; rx = x; },
      setCan: function (v) { hasCan = !!v; if (hasCan) multi = null; rebuild(); },
      setSize: function (id) { if (SIZES[id]) { sizeId = id; if (hasCan) rebuild(); } },
      size: function () { return sizeId; }
    };
    el.scClip = api;
    el.classList.add('is-ready');

    var visible = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(el);
    }
    function loop() {
      if (visible) {
        if (!down && auto) { vy *= .95; if (Math.abs(vy) < .004) vy = .004; ry += vy; }
        root.rotation.y = ry;
        if (clipGroup) {
          clipGroup.rotation.y = -turnDeg * Math.PI / 180;
          if (hasCan) {
            clipGroup.position.y = spec.panelY + .55 + lift * 20;
            clipGroup.rotation.x = tilt;
            if (tabUp) { tabUp.visible = lift < .06; tabFlat.visible = lift >= .06; }
          }
        }
        /* in een smalle, hoge viewer bepaalt de horizontale beeldhoek de afstand,
           anders vallen brede opstellingen (het rondje, het raster) buiten beeld */
        var half = 14 * Math.PI / 180;
        var hhalf = Math.atan(Math.tan(half) * Math.max(.3, cam.aspect || 1));
        var d2 = fit.rad / Math.sin(Math.min(half, hhalf)) * fit.mult;
        var ev = Math.max(-.25, Math.min(1.45, .55 + rx));
        cam.position.set(0, Math.sin(ev) * d2, Math.cos(ev) * d2);
        cam.lookAt(0, 0, 0);
        renderer.render(scene, cam);
      }
      if (!reduce) requestAnimationFrame(loop);
    }
    loop();

    function resize() {
      renderer.setSize(W(), H(), false);
      cam.aspect = W() / H(); cam.updateProjectionMatrix();
      if (reduce) renderer.render(scene, cam);
    }
    resize();
    new ResizeObserver(resize).observe(el);
  }

  window.SCClip3D = {
    mount: function (el) {
      if (el.scClip || el.__scMounting) return;
      el.__scMounting = true;
      loadThree().then(function () { build(el); })
        .catch(function (e) { if (window.console && console.error) console.error('SCClip3D', e && e.message || e); el.classList.add('scx-clip3d--fallback'); });
    }
  };
  function mountAll() { Array.prototype.forEach.call(document.querySelectorAll('[data-sc-clip3d]'), window.SCClip3D.mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll); else mountAll();
})();
